import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

// Utility to check JWT expiry
function isTokenExpired(token) {
  if (!token) return true;
  try {
    const [, payload] = token.split('.');
    const decoded = JSON.parse(atob(payload));
    if (!decoded.exp) return true;
    return Date.now() >= decoded.exp * 1000;
  } catch {
    return true;
  }
}

const ProtectedRoute = ({ allowedRoles, children }) => {
  // Get user role from localStorage
  const userRole = localStorage.getItem('role');
  const token = localStorage.getItem('token');

  // Check if user is authenticated and token is not expired
  if (!token || isTokenExpired(token)) {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('notifications');
    localStorage.removeItem('lastNotificationTime');
    window.dispatchEvent(new CustomEvent('app-logout'));
    // Optionally clear other user info here
    window.sessionStorage.setItem('sessionExpired', 'true');
    return <Navigate to="/login" replace />;
  }

  // Check if user has required role
  if (!allowedRoles.includes(userRole)) {
    // Redirect to dashboard if role not allowed
    return <Navigate to={`/${userRole}/dashboard`} replace />;
  }

  // Render the protected route
  return children || <Outlet />;
};

export default ProtectedRoute; 